module.exports = __webpack_public_path__ + "static/media/GooglePlay.62e561e1.svg";